import Joi from '@hapi/joi'

export const AddSupplierSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Company").messages({
        "any.invalid": `Select Company`,
        "any.required": `Company required`
    })
}

export const AddSupplierAddEditSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Company").messages({
        "any.invalid": `Select Company`,
        "any.required": `Company required`
    }),
    orderID: Joi.number().invalid(0).required().label("Order Number").messages({
        "any.invalid": `Select Order Number`,
        "any.required": `Order Number required`
    }),
    collectionTypeID: Joi.number().required().label("Item").messages({
        "any.invalid": `Item cannot have invalid characters`,
        "any.required": `Item required`
    }),
    customerID: Joi.number().invalid(0).required().label("Supplier").messages({
        "any.invalid": `Select Supplier`,
        "any.required": `Supplier required`
    }),
    quantity : Joi.number().positive().required().label("Quantity").messages({
        "number.positive": `Enter valid quantity`
    }),
    unitPrice : Joi.number().positive().required().label("Unit Price").messages({
        "number.positive": `Enter valid unit price`
    }),
    totalPrice : Joi.string().allow(null, '').label("Total Price"),
    supplyDate: Joi.string().invalid("").label("Supply Date")
}